const BRAND_COLOR = '#1F2A44'

export interface BrandLogoProps {
  variant?: 'full' | 'mark' | 'fullWhite' | 'markWhite'
  size?: 'sm' | 'md' | 'lg' | 'xl'
  className?: string
  /** @deprecated unused, kept for call-site compat */
  imageClassName?: string
}

const SIZE_PX = { sm: 24, md: 32, lg: 40, xl: 48 }

export function BrandLogo({
  variant = 'full',
  size = 'md',
  className = '',
}: BrandLogoProps) {
  const px = SIZE_PX[size]
  const isWhite = variant === 'fullWhite' || variant === 'markWhite'
  const isFullLogo = variant === 'full' || variant === 'fullWhite'

  const markBg = isWhite ? 'rgba(255,255,255,0.14)' : BRAND_COLOR
  const wordmarkColor = isWhite ? '#FFFFFF' : BRAND_COLOR

  const radius = Math.round(px * 0.25)
  const markFontSize = Math.round(px * 0.38)
  const wordmarkFontSize = Math.round(px * 0.52)
  const gap = Math.round(px * 0.32)

  return (
    <div
      className={`inline-flex items-center ${className}`}
      aria-label="ODOnboard"
      role="img"
    >
      {/* Mark */}
      <div
        style={{
          width: px,
          height: px,
          borderRadius: radius,
          background: markBg,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
        aria-hidden="true"
      >
        <span
          style={{
            fontSize: markFontSize,
            fontWeight: 700,
            color: '#FFFFFF',
            lineHeight: 1,
            letterSpacing: '-0.01em',
            fontFamily: 'inherit',
            userSelect: 'none',
          }}
        >
          OD
        </span>
      </div>

      {/* Wordmark — HTML text: never clips, inherits Inter */}
      {isFullLogo && (
        <span
          style={{
            marginLeft: gap,
            fontSize: wordmarkFontSize,
            fontWeight: 600,
            color: wordmarkColor,
            lineHeight: 1,
            letterSpacing: '-0.025em',
            whiteSpace: 'nowrap',
            userSelect: 'none',
            fontFamily: 'inherit',
          }}
          aria-hidden="true"
        >
          Onboard
        </span>
      )}
    </div>
  )
}
